import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithNProgress from 'app/utils/services/baseQueryWithNProgress';

export const routeApi = createApi({
	reducerPath: 'routeApi',
	baseQuery: baseQueryWithNProgress,
	endpoints: () => ({}),
});
